import moment from 'moment';

// import { format } from 'date-fns';
// import { ConfigService } from '../Configs/ConfigService';
// import { DateFormats, DateTimeFormats, TimeFormats } from './types/enum';
// import { DateTimeFormatsType } from './types/types';

export const formatTime24 = (str: string) => {
  if (str === '' || str === null || str === undefined) return '';
  else if (str.indexOf('T') > 0 || str.indexOf(' ') > 0) {
    let today = new Date(str);
    return moment(today).format('HH:mm');
  } else return str;
};

export const formatFullDate = (dateString: string, showYear: boolean = true, showWeekday: boolean = true) => {
  let date = new Date(dateString);
  let format = `${showWeekday ? 'dddd,' : ''} D MMMM ${showYear ? 'YYYY' : ''}`;
  return moment(date).format(format);
};

export const formatISODate = (date: string | Date) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return moment(date).format();
};

export const formatDateDMYYYY = (dateValue: Date) => {
  const day = dateValue.getDate();
  const month = dateValue.getMonth() + 1;
  const year = dateValue.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

// To format date in custom formats
export const dateTimeToCustomFormat = (inputDate: string = '', formatStr: string = 'DD/MM/YYYY'): string =>
  moment(new Date(inputDate)).format(formatStr);

export const UTCToCustomFormat = (inputDate: string, formatStr: string = 'DD/MM/YYYY'): string => {
  return moment(inputDate).format(formatStr);
};

export const UTCToLocal = (dateString: string) => {
  return new Date(new Date(dateString + 'Z'));
};
